declare namespace $ {

	type $shm_hitalama_text__text_shm_hitalama_map_widget_float_text_md_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text_md['text'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	type $shm_hitalama_text__favicon_shm_hitalama_map_widget_float_text_md_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text_md['link_favicon'] >
		,
		ReturnType< $shm_hitalama_text['favicon'] >
	>
	type $mol_button_download__title_shm_hitalama_map_widget_float_text_md_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__blob_shm_hitalama_map_widget_float_text_md_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text_md['md_download_blob'] >
		,
		ReturnType< $mol_button_download['blob'] >
	>
	type $mol_button_download__file_name_shm_hitalama_map_widget_float_text_md_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text_md['md_download_file_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_text_md_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_text_md_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text_md['link_favicon'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_widget_float_text_md_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_text_md_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_text_md_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pop_over__align_shm_hitalama_map_widget_float_text_md_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pop_over['align'] >
	>
	type $mol_pop_over__Anchor_shm_hitalama_map_widget_float_text_md_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text_md['Link_favicon_help_anchor'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_shm_hitalama_map_widget_float_text_md_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_text_md_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_widget_float_text_md extends $shm_hitalama_map_widget_float {
		text( ): string
		Md( ): $shm_hitalama_text
		md_download_blob( ): any
		md_download_file_name( ): string
		Md_download( ): $mol_button_download
		link_favicon( ): boolean
		Link_favicon( ): $mol_check_box
		Link_favicon_help_icon( ): $mol_icon_help_circle_outline
		Link_favicon_help_anchor( ): $mol_button_minor
		Link_favicon_help_text( ): $mol_view
		Link_favicon_help( ): $mol_pop_over
		Link_favicon_row( ): $mol_view
		controls( ): readonly(any)[]
		contextmenu_body( ): readonly(any)[]
		settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=md.view.tree.d.ts.map